/**
 * The Zuzahlungs-Kreuz the prescriber set on Muster 13.1/E (#1497).
 *
 * The form carries two separate boxes at its left margin, `Zuzahlungsfrei` and
 * `Zuzahlungspflichtig`, and **neither has a field in the 33-field PDF417
 * barcode** — so the scan path can never supply this and a Therapeut has to
 * type it off the sheet.
 *
 * Three-valued on purpose. `NOT_SPECIFIED` is the lawful normal case, not a
 * defect: the tick is no mandatory physician entry, and an empty one means the
 * practice decides for itself. It must therefore never hold a case up.
 *
 * ⚠ This does **not** answer "is this patient liable for a Zuzahlung". It is one
 * input among several, and in Podologie a physician's `EXEMPT` carries no
 * authority at all — there only a presented Befreiungsbescheinigung may suspend
 * collection. That evaluation lives in the §302 copayment derivation (#1499);
 * this enum only records what the sheet says.
 */
export var PhysicianCopaymentMark;
(function (PhysicianCopaymentMark) {
    /** No box ticked — the lawful normal case. */
    PhysicianCopaymentMark["NOT_SPECIFIED"] = "not_specified";
    /** `Zuzahlungsfrei` ticked. */
    PhysicianCopaymentMark["EXEMPT"] = "exempt";
    /** `Zuzahlungspflichtig` ticked. */
    PhysicianCopaymentMark["LIABLE"] = "liable";
})(PhysicianCopaymentMark || (PhysicianCopaymentMark = {}));
//# sourceMappingURL=physician-copayment-mark.enum.js.map